import type { TrackersSetupModalPayload } from "./types";

/** Figma 87676:37431 / 88100:38022 — Harness copy contract */
export const TRACKERS_SETUP_MOCK: TrackersSetupModalPayload = {
  headerTitle: "Meet Ed",
  headline: "Here's what I'll watch for you.",
  subhead: "These run quietly. I only ping you when something matters.",
  saveGoalArgs: {
    title: "Concentration guardrail",
    summary:
      "Bring single-name concentration into your 15% guardrail, staged over 6 months.",
    hasBoundPortfolio: true,
  },
  trackersSectionTitle: "Trackers I'll run",
  trackers: [
    {
      id: "rank-movement",
      title: "Rank Movement",
      description:
        "Pings when one of your top holdings changes rank in your book — early signal that concentration is creeping back.",
      status: "active",
    },
    {
      id: "earnings-call",
      title: "Earnings Call",
      description:
        "Pre and post-earnings read for every name you hold above 5% — so you know if a drop is noise or a real reason to trim.",
      status: "active",
    },
    {
      id: "alpha-picks",
      title: "Alpha Picks",
      description:
        "Sunday brief showing 1–2 substitute names that match your factor exposure — ready when you trim a tranche.",
      status: "active",
    },
  ],
  ctaLabelH5: "Save this setup",
  ctaLabelPc: "Save this Setup",
};
